<template>
  <div class="label-container">
    <div class="dots-left" :style="dotGapStyle">
      <span class="dot" :style="dotSmallStyle"></span>
      <span class="dot" :style="dotMediumStyle"></span>
      <span class="dot" :style="dotLargeStyle"></span>
    </div>
    <div class="text-content" :style="textStyle">
      <slot></slot>
    </div>
    <div class="dots-right" :style="dotGapStyle">
      <span class="dot" :style="dotLargeStyle"></span>
      <span class="dot" :style="dotMediumStyle"></span>
      <span class="dot" :style="dotSmallStyle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Label202510',
  props: {
    dotColor: {
      type: String,
      default: '#F7A121',
    },
    fontSize: {
      type: [String, Number],
      default: '16px',
    },
    fontColor: {
      type: String,
      default: '#000000',
    },
    dotSizeSmall: {
      type: [String, Number],
      default: 9,
    },
    dotSizeMedium: {
      type: [String, Number],
      default: 11,
    },
    dotSizeLarge: {
      type: [String, Number],
      default: 15,
    },
    dotGap: {
      type: [String, Number],
      default: 6,
    },
    textWidth: {
      type: [String, Number],
      default: 'auto',
    },
  },
  computed: {
    dotStyle() {
      return {
        backgroundColor: this.dotColor,
      };
    },
    textStyle() {
      const width = typeof this.textWidth === 'number' ? `${this.textWidth}px` : this.textWidth;
      return {
        fontSize: typeof this.fontSize === 'number' ? `${this.fontSize}px` : this.fontSize,
        color: this.fontColor,
        width,
      };
    },
    dotSmallStyle() {
      const size = typeof this.dotSizeSmall === 'number' ? `${this.dotSizeSmall}px` : this.dotSizeSmall;
      return {
        backgroundColor: this.dotColor,
        width: size,
        height: size,
      };
    },
    dotMediumStyle() {
      const size = typeof this.dotSizeMedium === 'number' ? `${this.dotSizeMedium}px` : this.dotSizeMedium;
      return {
        backgroundColor: this.dotColor,
        width: size,
        height: size,
      };
    },
    dotLargeStyle() {
      const size = typeof this.dotSizeLarge === 'number' ? `${this.dotSizeLarge}px` : this.dotSizeLarge;
      return {
        backgroundColor: this.dotColor,
        width: size,
        height: size,
      };
    },
    dotGapStyle() {
      const gap = typeof this.dotGap === 'number' ? `${this.dotGap}px` : this.dotGap;
      return {
        gap,
      };
    },
  },
};
</script>

<style scoped>
.label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.dots-left,
.dots-right {
  display: flex;
  align-items: center;
}

.dot {
  border-radius: 50%;
  display: inline-block;
}

.text-content {
  margin: 0 12px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}
</style>
